// extracted by mini-css-extract-plugin
export default {"cls1":"iGjIFyI6e8OMKJidJNut","cls2":"v8Yw0MnRYr2riOfD7gLz iGjIFyI6e8OMKJidJNut"};